// extracted by mini-css-extract-plugin
module.exports = {"row":"Row--row--26xi7"};